export default {
  API_URL: 'https://borr-api.cometrootapp.com/api/',
  SANDBOX_URL: 'https://borrsandbox-api.cometrootapp.com/api/'
  // API_URL: 'https://localhost:44365/api',
  // SANDBOX_URL: 'https://localhost:44365/api'
}
